import { Injectable } from '@angular/core';
import { ISettingsService, SettingAccessor } from '../ISettingsService';
import {
  LocalWallboxSettingsService,
  WallboxAppConfiguration,
} from '../../../../../apps/keba-wallbox-app/src/app/services/local-wallbox/settings/local-wallbox-settings.service';
import { KebaWallboxPlugin, ObjectKeys } from '../../../../../apps/keba-wallbox-app/src/plugins/keba-wallbox-plugin';
import { CurrentWallboxConfigService } from '../../../../../apps/keba-wallbox-app/src/app/services/current-wallbox-config.service';
import { M20Key } from '@kw-shared/common';

@Injectable({
  providedIn: 'root',
})
export class LocalSettingsService implements ISettingsService {
  private settingsReaderMap: Map<
    string,
    { method: (service: LocalSettingsService) => Promise<any>; resultSelector: (result: any) => any }
  >;

  constructor(
    private readonly localWallboxSettingsService: LocalWallboxSettingsService,
    private readonly currentWallboxConfigService: CurrentWallboxConfigService
  ) {
    this.settingsReaderMap = new Map();
    this.settingsReaderMap.set(M20Key.MAX_LICENSE, {
      method: this.readM20MaxLicense,
      resultSelector: (result: any) => {
        return result.maxClients.toString();
      },
    });
  }

  public async readSetting(settingAccessor: SettingAccessor): Promise<undefined | string | string[] | ObjectKeys> {
    if (settingAccessor.settingKey) {
      let settingReaderEntry = this.settingsReaderMap.get(settingAccessor.settingKey);
      if (settingReaderEntry) {
        let result = await settingReaderEntry.method(this);
        return settingReaderEntry.resultSelector(result);
      }
    }
    if (!settingAccessor.configurationType) {
      return undefined;
    }
    let resp = await this.localWallboxSettingsService.readConfiguration(
      settingAccessor.configurationType,
      settingAccessor.settingKey
    );
    if (!resp) {
      return undefined;
    }
    return settingAccessor.settingKey ? resp[settingAccessor.settingKey] : resp;
  }

  public getWallboxConfig(): WallboxAppConfiguration | undefined {
    const wallboxConfig = this.currentWallboxConfigService.getCurrentWallboxConfig();
    if (wallboxConfig?.isLocalWallbox()) {
      return wallboxConfig.toWallboxConfiguration();
    }
    return undefined;
  }

  private readM20MaxLicense(service: LocalSettingsService): Promise<{ maxClients: number }> {
    let config = service.getWallboxConfig();
    if (!config) {
      return Promise.reject();
    }
    return KebaWallboxPlugin.readMaxClientLicenseM20({ config });
  }
}
